// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"401":"3dfa6c2c7d4af7f0","639":"f1cfeef97738aaa2"}[chunkId] + ".js";
};